<!-- Start of Quick search common component -->
    <app-quick-search 
        [DefaultFilterArray]="DefaultFilterArray"
        [QuickSearchFilterArray]="quickFilterArray"
        (updateDefaultArray)="updateDefaultArray($event)"
        (clearQuickSearch)="clearQuickSearch($event)">
    </app-quick-search>
<!-- End of Quick search common component -->

<!--Filter Code  -->
<div class="col-lg-12 nopadding">
    <app-filter-panel [GridColumns]="GridColumns" [isAddFilter]=true [DefaultFilterArray]="DefaultFilterArray" (FilterEvent)="FilterApplyFilterEvent($event)">
    </app-filter-panel>
</div>

<!--Grid Code  -->
<div class="col-lg-12 nopadding">
    @if(isLoadingResults) {
    <div class="example-loading-shade">
        <mat-spinner></mat-spinner>
    </div>
    }
    <app-grid [GridColumns]="GridColumns" [Dataset]="dataset1" [TotalRecords]="totalRecords" [isExportEnabled] = false (RestLimitEvent)="GridChangeLimitEvent($event)">
    </app-grid>
</div>